import { Extension } from "@tiptap/core";

const renderStyle = (property, value) => (value ? { style: `${property}: ${value}` } : {});

const ControlledTextStyle = Extension.create({
  name: "controlledTextStyle",

  addGlobalAttributes() {
    return [
      {
        types: ["textStyle"],
        attributes: {
          fontSize: {
            default: null,
            parseHTML: (element) => element.style.fontSize || null,
            renderHTML: ({ fontSize }) => renderStyle("font-size", fontSize),
          },
          fontFamily: {
            default: null,
            parseHTML: (element) => element.style.fontFamily || null,
            renderHTML: ({ fontFamily }) => renderStyle("font-family", fontFamily),
          },
          letterSpacing: {
            default: null,
            parseHTML: (element) => element.style.letterSpacing || null,
            renderHTML: ({ letterSpacing }) => renderStyle("letter-spacing", letterSpacing),
          },
          fontVariant: {
            default: null,
            parseHTML: (element) => element.style.fontVariant || null,
            renderHTML: ({ fontVariant }) => renderStyle("font-variant", fontVariant),
          },
        },
      },
      {
        types: ["paragraph", "heading"],
        attributes: {
          indent: {
            default: 0,
            parseHTML: (element) => Number(element.dataset.indent || 0),
            renderHTML: ({ indent }) =>
              indent
                ? {
                    "data-indent": indent,
                    style: `margin-left: ${indent * 2}rem`,
                  }
                : {},
          },
          lineHeight: {
            default: null,
            parseHTML: (element) => element.style.lineHeight || null,
            renderHTML: ({ lineHeight }) => renderStyle("line-height", lineHeight),
          },
          paragraphSpacing: {
            default: null,
            parseHTML: (element) => element.style.marginBottom || null,
            renderHTML: ({ paragraphSpacing }) => renderStyle("margin-bottom", paragraphSpacing),
          },
          direction: {
            default: null,
            parseHTML: (element) => element.getAttribute("dir") || element.style.direction || null,
            renderHTML: ({ direction }) => (direction ? { dir: direction } : {}),
          },
        },
      },
    ];
  },
});

export default ControlledTextStyle;
